import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';

import { ContentStatus } from '../constants/ContentStatus';

import { preloadContentDataClassification } from './preloadContentDataClassification';

export async function preloadClassificationContextForViewContent(contentId: string): Promise<any> {
	const queries: Promise<any>[] = [];

	queries.push(preloadContentDataClassification(contentId, ContentStatus.CURRENT));

	return waitForAllReturnWhenError(queries);
}
